<script lang="ts">
  import { useSessionStore } from '$lib/utils/session-store';
  import classnames from 'classnames';
  import { useCookiesStore } from '$lib/utils/cookie-store';
	import Checkbox from './Checkbox.svelte';
	import { Tooltip, TooltipDesktop } from '$lib/components/atoms/Tooltip';
	import { Icon } from '$lib/components/atoms/Icon';

  const sessionStore = useSessionStore();
  const companyStatus = sessionStore.companyStatus;
  const cookiesStore = useCookiesStore();
  const companyAB = cookiesStore.companyAB;

  const tooltipMessage: string = 'Se selezioni questa opzione ti potremo mostrare servizi molto richiesti dalle aziende';

  const onCompanyStatusChange = (status) => {
    sessionStore.setCompanyStatus(status);
  };
</script>

<section>
  {#if $companyAB === 'B'}
  <Checkbox id="b2b" name="b2b" class="w-max"
    value={true}
    currentValue={$companyStatus}
    on:input={() => onCompanyStatusChange(!$companyStatus)}>
      <div class={classnames("flex flex-1 justify-between", $$props.class)}>
        <span class="mr-2">Sto acquistando per conto di un’azienda</span>
        <div class="block md:hidden">
          <Tooltip message={tooltipMessage}>
            <span class="cursor-pointer text-gray-900"> <Icon icon="info" size="middle" /></span>
          </Tooltip>
        </div>
        <div class="hidden md:block">
          <TooltipDesktop position="top-left" message={tooltipMessage}/>
        </div>
      </div>
  </Checkbox>
  {/if}
</section>
